module.exports = __webpack_public_path__ + "static/media/card-customer-bg.61da18c0.svg";